import { api_GET, api_POST, api_PUT } from "./_api.js";

const documento_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Documento")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Documento/GetListAtivos")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Documento", documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (documento) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Documento", documento)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default documento_api;
